import { render, staticRenderFns } from "./skill-activity.vue?vue&type=template&id=364840d3&scoped=true&"
import script from "./skill-activity.vue?vue&type=script&lang=js&"
export * from "./skill-activity.vue?vue&type=script&lang=js&"
import style0 from "./skill-activity.vue?vue&type=style&index=0&id=364840d3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364840d3",
  null
  
)

export default component.exports